
<template>
    <div class="center">
      <vs-dialog prevent-close v-model="active" @close="active = false">
        <template #header>
          <h4 class="not-margin">
            Eliminar Reglas de cobro
          </h4>
        </template>
        <div class="con-form text-center">
            <h5>La Regla de cobro se eliminaría permanentemente</h5>
        </div>

        <template #footer>
          <div class="footer-dialog">
              <vs-row>
                  <vs-col sm="6" lg="6">
                    <vs-button
                        danger
                        flat
                        @click="active = false">
                        Cancelar
                    </vs-button>
                  </vs-col>
                  <vs-col sm="6" lg="6">
                    <vs-button
                        success
                        class="ml-auto"
                        @click="postEliminarReglaCobro()">
                        Aceptar
                    </vs-button>
                  </vs-col>
              </vs-row>
          </div>
        </template>
      </vs-dialog>
    </div>
</template>
<script>
import administracion from '../../../../../api/requests/administracion'
export default {
    props:[
        'value',
        'selectedRow'
    ],
    data:() => ({
        active: false,
    }),
    methods: {
        async postEliminarReglaCobro(){
            const loading = this.$vs.loading()
            try{
                const formData = new FormData();
                formData.append("id", this.selectedRow.id)
                const { data: response } = await administracion.postEliminarReglaCobro(this.selectedRow.id, formData)
                loading.close()
                this.active = false
                this.$emit('refreshTable')
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: null,
                    title: 'Operación éxitosa.',
                    text: 'Se eliminó con éxito el registro.'
                })
            }catch(error){
                loading.close()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    title: 'Algo salió mal.',
                    text: error.response.data.message
                })
            }
        }
    },
    watch:{
      value (val) {
          this.active = val
      },
      async active (val) {
          if (!val){
              this.$emit('input', val);
          }
      },
    }
}
</script>

<style lang="scss" scoped>
    .tache{
        position: absolute;
        cursor: pointer;
        top: 35px;
        @media only screen and (max-width: 768px) {
            left: calc(95% - 4em);
        }
        @media only screen and (min-width: 768px) {
            left: calc(98% - 4em);
        }

    }
</style>